import Navbar from "../../common/components/HomeNavbar";
import S2rContent from "./components/S2rContent";
import FreeRenderLimit from "./components/FreeRenderLimit";

import "./index.scss";
import grid from "../../assets/grid.png";

import { withAuthorization } from "../../common/auth/session";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import useRefreshProfile from "../../common/Hooks/useRefreshProfile";
import useFreeUserImageCount from "./Hooks/useFreeUserImageCount";
import useRedirectToCheckout from "../../common/Hooks/useRedirectToCheckout";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const S2R = () => {
  useRefreshProfile();
  useRedirectToCheckout();
  const [freeUserCanRender] = useFreeUserImageCount();

  return (
    <>
      <Navbar title="S2R v.0.0.3" />
      <div
        style={{
          backgroundColor: "#141414",
          backgroundImage: `url(${grid})`,
          display: "flex",
          flexDirection: "row",
          width: "100%",
          height: "100%",
        }}
      >
        <div style={{ width: "100%", height: "100%" }}>
          {freeUserCanRender ? <S2rContent /> : <FreeRenderLimit />}
        </div>
      </div>
    </>
  );
};

const condition = (authUser) => !!authUser;

export default compose(withAuthorization(condition), withRouter)(S2R);
